module.exports = __webpack_public_path__ + "img/10.80e609b5.jpg";